import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

/** Distinct from skipped orange: warning header, chips, and stat card. */
export const PROCESS_WARNING_ACCENT = rydeColors.steel;

export const ProcessWrapperStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "process-wrapper-styled",
})`
  padding-inline-end: 48px;
  padding-block-end: 24px;
`;

export const ProcessSummaryBlockStyled = styled.div`
  margin-block-start: 16px;
  padding: 16px;
  border-radius: 12px;
  background: ${rydeColors.smoke};
  border: 1px solid ${rydeColors.lightGreyBorder};
`;

export const ProcessStatsGridStyled = styled.div<{ $columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, minmax(0, 1fr));
  gap: 8px;
`;

export const ProcessStatCardStyled = styled.div<{ $accent: string }>`
  padding: 10px 12px;
  border-radius: 10px;
  background: ${rydeColors.white};
  border: 1px solid ${rydeColors.lightGreyBorder};
  border-inline-start: 4px solid ${({ $accent }) => $accent};
`;

export const ProcessStatLabelStyled = styled.div`
  color: ${rydeColors.grey};
  font-size: 12px;
  line-height: 1.3;
`;

export const ProcessStatValueStyled = styled.div<{ $color: string }>`
  margin-block-start: 4px;
  color: ${({ $color }) => $color};
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
`;

export const ProcessSplitBarStyled = styled.div`
  display: flex;
  overflow: hidden;
  height: 8px;
  margin-block-start: 14px;
  border-radius: 999px;
  background: ${rydeColors.lightGrey};
`;

export const ProcessSplitBarSegmentStyled = styled.div<{
  $flex: number;
  $color: string;
}>`
  flex: ${({ $flex }) => $flex};
  background: ${({ $color }) => $color};
`;

export const ProcessSummaryCaptionStyled = styled.div`
  margin-block-start: 8px;
  color: ${rydeColors.placeholder};
  font-size: 13px;
  line-height: 1.4;
`;

export const ProcessIdsSectionStyled = styled.div`
  margin-block-start: 14px;
`;

export const ProcessIdsTitleStyled = styled.div`
  flex: 1;
  margin-block-end: 8px;
  color: ${rydeColors.grey};
  font-size: 12px;
  font-weight: 600;
`;

export const ProcessIdsWrapStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const ProcessErrorsTableWrapStyled = styled.div`
  margin-block-start: 4px;
  overflow: hidden;
  border: 1px solid ${rydeColors.lightGreyBorder};
  border-radius: 10px;
  background: ${rydeColors.white};

  .MuiTableCell-head {
    color: ${rydeColors.grey};
    font-weight: 600;
    background: ${rydeColors.smoke};
  }

  .MuiTableCell-root {
    border-color: ${rydeColors.lightGreyBorder};
  }
`;
